import { GraphQLError } from "graphql";
import { Exchange, ExchangeIO, Operation, OperationResult } from "urql";
import { filter, map, merge, pipe, Source } from "wonka";
import { isDemoMode } from "@/config";

/**
 * DEMOモードでは、Mutationの実行をブロックするExchange
 */
export const demoModeExchange: Exchange = ({
  forward,
}: {
  forward: ExchangeIO;
}) => {
  return (operations$: Source<Operation>) => {
    if (!isDemoMode) {
      return forward(operations$);
    }

    const isMutation = (operation: Operation): boolean =>
      operation.kind === "mutation";

    const blockedMutations$ = pipe(
      operations$,
      filter(isMutation),
      map((operation: Operation): OperationResult => {
        const message =
          "This is demo mode. Creating, updating, and deleting some resources are disabled.";
        console.warn(message);
        return {
          operation,
          data: undefined,
          error: {
            name: "DemoModeError",
            message: message,
            graphQLErrors: [new GraphQLError(message)],
          },
          extensions: undefined,
          hasNext: false,
          stale: false, // stale プロパティを追加
        };
      }),
    );

    const operationsToForward$ = pipe(
      operations$,
      filter((operation) => !isMutation(operation)),
    );

    return merge([blockedMutations$, forward(operationsToForward$)]);
  };
};
